module.exports = __webpack_public_path__ + "media/images/webpage/rich-contents/bg-pattern-dotted-c42ef34f80f5964426875d05cb48019b.svg";